<div bsModal #modal="bs-modal" class="modal fade center-modal" tabindex="-1" [config]="{backdrop: false, keyboard: false, ignoreBackdropClick: true}" [style.z-index]="zIndex">
    <div class="modal-dialog modal-dialog-centered" [class.modal-dialog-scrollable]="scrollable" [style.max-width]="maxWidth">
        <div class="modal-content bg-white p-24" style="border-radius: 10px; border: 1px solid rgb(229, 231, 235); box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);">
            <div class="mb-2">
                <p class="f-size-16 text-gray-900 font-weight-semibold mb-0 line-height-normal">{{title}}</p>
            </div>
            <div class="mt-3">
                <p *ngIf="failure" class="f-size-14 text-gray-500 mb-0" style="line-height: 1.6;">{{ displayMessage }}</p>
                <ng-content></ng-content>
            </div>
            <div class="d-flex align-items-center justify-content-end gap-8 mt-4">
                <button *ngIf="isDefaults || hasCancelButton" type="button" (click)="onCancel()" class="vf-modal-cancel-btn">{{cancelLabel}}</button>
                <button *ngIf="hasSaveButton || (failure && !hasCancelButton)" type="button" [disabled]="isLoading || saveDisabled" (click)="onSave()"
                    class="btn btn-black h-36 px-12 py-10 font-weight-medium d-flex align-items-center gap-4 rounded-sm">
                    {{saveLabel}}
                </button>
            </div>
        </div>
    </div>
</div>
